import { render, staticRenderFns } from "./CSidebarItem.vue?vue&type=template&id=6d5c265c"
import script from "./CSidebarItem.vue?vue&type=script&lang=js"
export * from "./CSidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d5c265c')) {
      api.createRecord('6d5c265c', component.options)
    } else {
      api.reload('6d5c265c', component.options)
    }
    module.hot.accept("./CSidebarItem.vue?vue&type=template&id=6d5c265c", function () {
      api.rerender('6d5c265c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CSidebarItem.vue"
export default component.exports